import {TemplateConfig} from '../../dto/response/template.config';

export class GetTemplateConfig {
  static readonly type = '[Template Config] Get';
}


export class UpdateTemplateConfig {
  static readonly type = '[Template Config] Update';

  constructor(public templateCconfig: TemplateConfig) {}
}

